export const ORDER_STATUSES = [
  { value: "confermato", label: "Nuovo" },
  { value: "in_preparazione", label: "In preparazione" },
  { value: "spedito", label: "Spedito" },
  { value: "consegnato", label: "Consegnato" },
  { value: "annullato", label: "Annullato" },
  { value: "composto", label: "Box composto" },
];

export const statusLabel = Object.fromEntries(ORDER_STATUSES.map((s) => [s.value, s.label]));

export const statusColor = {
  confermato: "bg-white/10 text-ink border-white/25",
  in_preparazione: "bg-amber/15 text-amber border-amber/40",
  spedito: "bg-sky-400/15 text-sky-300 border-sky-400/40",
  consegnato: "bg-lime/15 text-lime border-lime/40",
  annullato: "bg-terra/15 text-terra border-terra/40",
  composto: "bg-sage/15 text-sage border-sage/40",
};
